import { ContactForEdgePropsSchema, EmptyEdgePropsSchema } from '../../graph-schemas/edges/common';
import type { EdgeDefinition } from './base-crm';

export const SALES_EDGES: Record<string, EdgeDefinition> = {
  OPPORTUNITY_FOR: {
    type: 'OPPORTUNITY_FOR',
    schema: EmptyEdgePropsSchema,
    displayName: 'Opportunity For',
    reverseDisplayName: 'Has Opportunity',
    sourceTypes: ['Opportunity', 'FundraisingOpportunity'],
    targetTypes: ['Organization', 'Vehicle'],
    props: [
      { key: 'pipeline_id', label: 'Pipeline ID', type: 'text' },
      { key: 'entered_stage_at', label: 'Entered Stage At', type: 'date' },
    ],
  },
  HAS_CONTACT: {
    type: 'HAS_CONTACT',
    schema: ContactForEdgePropsSchema,
    displayName: 'Has Contact',
    reverseDisplayName: 'Contact For',
    // Deal: a HubSpot deal's contacts (apps/api/src/connectors/hubspot/normalize/deal.ts)
    sourceTypes: ['Opportunity', 'Deal'],
    targetTypes: ['Person'],
    props: [
      { key: 'role', label: 'Role', type: 'select', options: ['champion', 'executive_sponsor', 'technical_evaluator', 'influencer', 'blocker', 'decision_maker', 'end_user'] },
      { key: 'notes', label: 'Notes', type: 'text' },
    ],
  },
  ASSIGNED_TO: {
    type: 'ASSIGNED_TO',
    schema: EmptyEdgePropsSchema,
    displayName: 'Assigned To',
    reverseDisplayName: 'Assigned',
    sourceTypes: ['Opportunity', 'Deal', 'Task'],
    targetTypes: ['Person'],
    props: [{ key: 'role', label: 'Role', type: 'text' }],
  },
};
